var SINGLE_ROW_SELECT = 'single';
var MULTIPLE_ROW_SELECT = 'multiple';

export { MULTIPLE_ROW_SELECT, SINGLE_ROW_SELECT };
